import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { get } from 'lodash';
import innerAnalyticsVolia from 'helpers/innerAnalyticsVolia';
import { navigateToPlayerPage, resolveTimeShiftPlayer } from 'actions/player';
import { getIsLifecellFlag, getIsLoggedInSelector } from 'reducers/profile/selectors';
import { selectIsParentalControlEnabled } from 'reducers/parental-lock/selectors';
import PLAYER_TYPES from 'constants/player-types';
import { MISSING_SUBSCRIPTION } from 'constants/visibility-types';
import useModals from 'hooks/useModals';
import { resolvePlayerNavLink } from 'helpers/urlhelper';
import { navigateToAuthPage } from 'actions/app';

export default () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const isLoggedIn = useSelector(getIsLoggedInSelector);
  const isParentalEnabled = useSelector(selectIsParentalControlEnabled);
  const isLifecellUser = useSelector(getIsLifecellFlag);
  const { showEnterPinModal, showLifecellPaymentModal } = useModals();

  const onEnter = useCallback(
    async (item, focusBackConfig, analyticsParams) => {
      const isAdult = get(item.pgRating, ['minRecomendedAge'], 0) === 18;
      const goToPlayer = () => {
        dispatch(
          navigateToPlayerPage({
            item: { id: item.id || item.channelId },
            type: PLAYER_TYPES.CHANNEL,
          }),
        );
      };

      const addInfo = `vod_asset_id=null;channel_id=${item.id};content_type=EPG_EVENT;type=CHANNEL;epgEventState=LIVE`;

      if (analyticsParams) innerAnalyticsVolia.postEvent({ ...analyticsParams, addInfo });

      const timeshiftBegin = await dispatch(resolveTimeShiftPlayer({ id: item.id || item.channelId }));
      const onSuccess = resolvePlayerNavLink(
        { id: item.id || item.channelId },
        { type: PLAYER_TYPES.CHANNEL, timeshiftBegin },
      );

      if (!isLoggedIn) {
        const search = `?channelId=${item.id || item.channelId}&onSuccess=${onSuccess}`;
        dispatch(navigateToAuthPage(search));
        return;
      }
      if (item.visibilityDetails === MISSING_SUBSCRIPTION) {
        if (isLifecellUser) {
          showLifecellPaymentModal({ id: item.id, assetType: 'channelId', onSuccess: goToPlayer }, focusBackConfig);
          return;
        }
        return history.push({
          pathname: '/profile/packages/filter',
          search: `?channelId=${item.id || item.channelId}&onSuccess=${onSuccess}`,
        });
      }
      if (isParentalEnabled && isAdult) {
        return showEnterPinModal(focusBackConfig, goToPlayer);
      }

      goToPlayer();
    },
    [dispatch, history, isLifecellUser, isLoggedIn, isParentalEnabled, showEnterPinModal, showLifecellPaymentModal],
  );

  return onEnter;
};
